// Ported from audio-web `modules/author/lib/isAnonymousAuthor`: the reserved username for
// unclaimed/anonymous uploads.
export const isAnonymousAuthor = (authorUsername: string): boolean => authorUsername === 'anonymous'
